



















































import { Component } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { Picture } from '@/components/atoms';

import { OnboardingURL } from '@/views/Onboarding/helpers';

import BrandedCoin from './Sections/BrandedCoin.vue';
import Loyalty from './Sections/Loyalty.vue';
import Offers from './Sections/Offers.vue';
import GiftCards from './Sections/GiftCards.vue';
import { DEFAULT_BRANDED_COIN_IMAGE } from './Constants';

import {
  SmartBusinessSignupData,
  SmartBusinessSignupDataResponse
} from '@/models/smart-business-signup';
import { smartBusinessSignupDataDefault } from '@/store/modules/businessOnboarding';
import YourDigitalCoinBase from '@/views/BusinessOnboarding/online/Steps/YourDigitalCoinBase.vue';
import { ReserveCoinInformations } from '@/models/coin-setup';
import { BusinessOnboardingYourDigitalCoinsForm } from '@/models/business-onboarding';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    FilledButton,
    Typography,
    Picture,
    BrandedCoin,
    Loyalty,
    GiftCards,
    Offers
  }
})
export default class Campaigns extends YourDigitalCoinBase {
  formData: SmartBusinessSignupData = smartBusinessSignupDataDefault;

  coinSelectIds = {
    front: 'coin-mirror-svg-element-edit-front',
    back: 'coin-mirror-svg-element-edit-back'
  };

  get brandedImages() {
    return (
      (this.smartBusinessSignupData.generateBrandedCoins &&
        this.smartBusinessSignupData.generateBrandedCoins.images) ||
      []
    );
  }
  get loyaltyOptions(): [number, string][] {
    return this.generatePercentageOptions(
      this.generatedSmartBusinessResponse.loyaltyAndGiftPercentageRecommendation
        .loyaltyPercentage || 0
    );
  }

  get giftOptions(): [number, string][] {
    return this.generatePercentageOptions(
      this.generatedSmartBusinessResponse.loyaltyAndGiftPercentageRecommendation
        .giftPercentage || 0
    );
  }

  get defaultSelectedLoyaltyValue() {
    if (
      this.smartBusinessSignupData &&
      this.smartBusinessSignupData.loyaltyPercentageRecommendation
    ) {
      return (
        this.smartBusinessSignupData.loyaltyPercentageRecommendation
          .percentage || 0
      );
    }
    return null;
  }

  get defaultSelectedGiftValue() {
    if (
      this.smartBusinessSignupData &&
      this.smartBusinessSignupData.giftPercentageRecommendation
    ) {
      return (
        this.smartBusinessSignupData.giftPercentageRecommendation.percentage ||
        0
      );
    }
    return null;
  }

  get smartBusinessSignupData(): SmartBusinessSignupData {
    return this.$store.getters['businessOnboarding/getSmartBusinessSignup'];
  }

  get generatedSmartBusinessResponse(): SmartBusinessSignupDataResponse {
    return this.$store.getters[
      'businessOnboarding/getGeneratedSmartBusinessResponse'
    ];
  }

  get businessData(): any {
    return this.$store.getters['businessOnboarding/getStoreDetailsForm'];
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get validLoyaltyAndGift() {
    if (
      !this.formData.loyaltyPercentageRecommendation.enabled ||
      !this.formData.giftPercentageRecommendation.enabled
    )
      return true;

    return (
      this.formData.loyaltyPercentageRecommendation.percentage <=
      this.formData.giftPercentageRecommendation.percentage
    );
  }

  get validBrandedCoin() {
    return this.formData.generateBrandedCoins.brandedCoinSelected.url;
  }

  get disabledSubmit() {
    return !this.validLoyaltyAndGift || !this.validBrandedCoin;
  }

  generatePercentageOptions(value: number): [number, string][] {
    if (value - 2 <= 0) {
      return [
        [value, `${value}%`],
        [value + 2, `${value + 2}%`],
        [value + 4, `${value + 4}%`]
      ];
    }
    return [
      [value - 2, `${value - 2}%`],
      [value, `${value}%`],
      [value + 2, `${value + 2}%`]
    ];
  }

  onChange(data: any, key: keyof SmartBusinessSignupData) {
    this.formData[key] = data;
  }

  async handleReserveCoinInformations(
    payload: ReserveCoinInformations,
    formData: BusinessOnboardingYourDigitalCoinsForm,
    images?: Record<string, any>
  ) {
    this.formData.generateBrandedCoins.brandedCoinSelected.additionalData = payload;
  }

  async onSubmit() {
    if (this.disabledSubmit) return;

    segmentIo.track('AI Sign Up | Create Free Account Button', {
      'Offers Active': this.formData.offersRecommendation.enabled,
      'Loyalty Active': this.formData.loyaltyPercentageRecommendation.enabled,
      'Gift Active': this.formData.giftPercentageRecommendation.enabled
    });

    await this.handleSubmit({
      coinName: '',
      isLoadingImg: false,
      coinShowFront: true,
      ...this.formData.generateBrandedCoins,
      ...(DEFAULT_BRANDED_COIN_IMAGE !==
      this.formData.generateBrandedCoins.brandedCoinSelected.url
        ? {
            image: {
              imageName: '',
              imageUrl: this.formData.generateBrandedCoins.brandedCoinSelected
                .url
            }
          }
        : {})
    });

    this.$store.dispatch('businessOnboarding/SET_SMART_BUSINESS_SIGNUP', {
      ...this.formData
    });

    this.$router.push(OnboardingURL.AI_USER_SIGN_UP);
  }

  created() {
    this.formData = {
      ...this.smartBusinessSignupData
    };
  }
}
